import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIRouterModule } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { CategoriesService } from '../shared/category/categories.service';
import { Process } from '../shared';
import * as fromExpense from '.';
import { ExpensesModule } from '.';
import { processResolver } from '../efaact-routing/process-resolver';
const log = new LoggingService();

// TODO: split these into areas

@NgModule({
    imports: [
        CommonModule,
        ExpensesModule,
        UIRouterModule.forChild({
            // TODO: will having all these here mess with lazy loading of modules?
            // https://ui-router.github.io/guide/lazyloading
            states: [
                {
                    name: 'expensereport',
                    url: '/expensereport',
                    data: { requiresAuth: true },
                    params: { process: {} },
                    resolve: [
                        {
                            token: 'process',
                            deps: [Transition, CategoriesService],
                            resolveFn: processResolver
                        }
                    ],
                    component: fromExpense.ExpenseListFeatureComponent
                },
                {
                    name: 'expensereport.entry',
                    url: '/entry',
                    component: fromExpense.ExpenseListFeatureComponent
                },
                {
                    name: 'expensereport.super',
                    url: '/super',
                    component: fromExpense.ExpenseListFeatureComponent
                },
                {
                    name: 'expensereport.validate',
                    url: '/validate',
                    component: fromExpense.ExpenseListFeatureComponent
                },
                {
                    name: 'expensereport.approval',
                    url: '/approve',
                    component: fromExpense.ExpenseListFeatureComponent
                },
                {
                    name: 'expensereport.travelrequest',
                    url: '/travel',
                    component: fromExpense.ExpenseListFeatureComponent
                },
                {
                    name: 'expensereport.travelrequestapproval',
                    url: '/approvetravel',
                    component: fromExpense.ExpenseListFeatureComponent
                },
                {
                    name: 'expenserequest',
                    url: '/expenserequest',
                    redirectTo: 'expensereport.travelrequest'
                }
            ]
        })
    ]
})
export class ExpensesRoutingModule {}
